import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { ConfirmationDialog, TextField } from '@statsbomb/kitbag-components';

export function Confirm({
  cancelLabel,
  confirmLabel,
  children,
  id,
  isOpen,
  isDisabledConfirm,
  onCancel,
  onConfirm,
  requiredConfirmationText,
  title,
}) {
  const intl = useIntl();

  const [confirmationMatched, setConfirmationMatched] = useState(false);

  const handleConfirmationTextChange = (event) =>
    setConfirmationMatched(event.target.value === requiredConfirmationText);

  const isSubmissable = !requiredConfirmationText || confirmationMatched;

  const defaultConfirmLabel = intl.formatMessage({
    defaultMessage: 'Confirm',
    id: '70d9b',
  });

  return (
    <ConfirmationDialog
      cancelLabel={cancelLabel}
      confirmLabel={confirmLabel || defaultConfirmLabel}
      id={id}
      isOpen={isOpen}
      isDisabledConfirm={!isSubmissable || isDisabledConfirm}
      onCancel={onCancel}
      onConfirm={onConfirm}
      title={
        title || (
          <FormattedMessage
            description="Confirmation title"
            defaultMessage="Are you sure?"
            id="86777"
          />
        )
      }
    >
      {children}
      {requiredConfirmationText && (
        <TextField
          id="confirmation-text"
          onChange={handleConfirmationTextChange}
          label={intl.formatMessage(
            {
              defaultMessage:
                'Please type "{requiredConfirmationText}" into this text box to proceed',
              description: 'Confirmation explanation',
              id: '346e7',
            },
            { requiredConfirmationText },
          )}
          variant="secondary"
        />
      )}
    </ConfirmationDialog>
  );
}

Confirm.propTypes = {
  cancelLabel: PropTypes.string,
  children: PropTypes.node,
  confirmLabel: PropTypes.string,
  id: PropTypes.string.isRequired,
  isDisabledConfirm: PropTypes.bool,
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  requiredConfirmationText: PropTypes.string,
  title: PropTypes.string,
};

Confirm.defaultProps = {
  cancelLabel: undefined,
  children: undefined,
  confirmLabel: undefined,
  isDisabledConfirm: false,
  isOpen: false,
  onCancel: () => {},
  onConfirm: () => {},
  requiredConfirmationText: undefined,
  title: undefined,
};

export default { Confirm };
